/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import {
  getProductNameListApi,
  productListApi,
  updateProductStatusApi,
} from "../../services/_product";
import { Link } from "react-router-dom";
import moment from "moment";
import Pagination from "../../components/Pagination";
import { getPermissions } from "../../context/AuthContext";
import ViewProduct from "./ViewProduct";
import Spinner from "../../theme/Spinner";
import { Autocomplete, TextField } from "@mui/material";

const ProductList = () => {
  const permissions = getPermissions();
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const [productId, setProductId] = useState<string>("");
  const [filterName, setFilterName] = useState<string>("");
  const [filterVariety, setFilterVariety] = useState<string>("");
  const [filterHsnNo, setFilterHsnNo] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [displayFilter, setDisplayFilter] = useState(false);
  const [userSuggestions, setUserSuggestions] = useState([]);
  const [filteredNameSuggestions, setFilteredNameSuggestions] = useState([]);
  const [filteredHsnNoSuggestions, setFilteredHsnNoSuggestions] = useState([]);
  const [filteredVarietySuggestion, setFilteredVarietySuggestion] = useState(
    []
  );
  const [sortKey, setSortKey] = useState<string>("");
  const [sortType, setSortType] = useState<string>("");

  const toggleFilter = async () => {
    setDisplayFilter(!displayFilter);
  };

  const getProductList = async (
    page: number,
    perPage: number,
    isFilter?: boolean,
    sortKey?: string,
    sortType?: string
  ) => {
    setLoading(true);
    let query = `page=${page}&per_page=${perPage}`;
    if (isFilter) {
      if (filterName) {
        query += `&name=${filterName}`;
      }
      if (filterVariety) {
        query += `&variety=${filterVariety}`;
      }
      if (filterHsnNo) {
        query += `&hsn_no=${filterHsnNo}`;
      }
      if (sortKey && sortType) {
        query += `&sort_key=${sortKey}&sort_type=${sortType}`;
      }
    }
    const result: any = await productListApi(query);
    if (result.isSuccess) {
      const totalPagesCount = Math.ceil(result.data.total_records / perPage);
      setTotalRecords(result.data.total_records);
      setTotalPages(totalPagesCount);
      setRecords(result.data.records);
    }
    setLoading(false);
  };

  const handleAutocompleteFilter = (
    filterType: "hsn_no" | "name" | "variety",
    newValue: string | null
  ) => {
    const filterData = userSuggestions.filter((suggestion: any) =>
      suggestion[filterType]
        ?.toLowerCase()
        .includes((newValue || "").toLowerCase())
    );
    if (filterType === "name") {
      setFilterName(newValue || "");
      setFilteredNameSuggestions(filterData);
    }
    if (filterType === "variety") {
      setFilterVariety(newValue || "");
      setFilteredVarietySuggestion(filterData);
    }
    if (filterType === "hsn_no") {
      setFilterHsnNo(newValue || "");
      setFilteredHsnNoSuggestions(filterData);
    }
  };

  useEffect(() => {
    const fetchSuggestions = async () => {
      const result: any = await getProductNameListApi();
      if (result.isSuccess) {
        setFilteredNameSuggestions(result?.data || []);
        setFilteredHsnNoSuggestions(result?.data || []);
        setFilteredVarietySuggestion(result?.data || []);
        setUserSuggestions(result?.data || []);
      }
    };
    fetchSuggestions();
  }, []);

  const filterList = async () => {
    setApplyFilter(true);
    setFilterName(filterName);
    setFilterHsnNo(filterHsnNo);
    setFilterVariety(filterVariety);
    getProductList(page, perPage, true);
  };

  const resetList = async () => {
    setPage(1);
    setApplyFilter(false);
    setFilterName("");
    setFilterHsnNo("");
    setFilterVariety("");
    setFilteredNameSuggestions(userSuggestions);
    setFilteredHsnNoSuggestions(userSuggestions);
    setFilteredVarietySuggestion(userSuggestions);
    getProductList(page, perPage);
  };

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  const updateProductStatus = async (id: string, status: boolean) => {
    setLoading(true);
    await updateProductStatusApi({
      id: id,
      status: !status,
    });
    setProductId("");
    getProductList(page, perPage, true);
    setLoading(false);
  };

  const sortTable = async (key: string) => {
    let type = sortType === "asc" ? "desc" : "asc";
    if (sortKey !== key) {
      type = "asc";
    }
    setSortKey(key);
    setSortType(type);
    await getProductList(page, perPage, true, key, type);
  };

  useEffect(() => {
    if (page && perPage) {
      getProductList(page, perPage, applyFilter);
    }
  }, [page, perPage, applyFilter]);

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>Product List</h5>
          </div>

          <div>
            <Link
              to="#"
              type="button"
              className="btn btn-label-github"
              style={{ marginRight: "15px" }}
              onClick={toggleFilter}
            >
              <span>
                <i className="ti ti-filter me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Filter</span>
              </span>
            </Link>
            {permissions.includes("create-product") && (
              <Link
                className="btn btn-primary waves-effect waves-light"
                type="button"
                to="/create-product"
              >
                <span>
                  <i className="ti ti-plus me-sm-1"></i>{" "}
                  <span className="d-none d-sm-inline-block">Add Product</span>
                </span>
              </Link>
            )}
          </div>
        </div>

        {displayFilter && (
          <div className="card-body">
            <form className="dt_adv_search">
              <div className="row">
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Name:
                      </label>
                      <Autocomplete
                        disablePortal
                        options={filteredNameSuggestions.map(
                          (suggestion: any) => suggestion.name
                        )}
                        onChange={(event, newValue) =>
                          handleAutocompleteFilter("name", newValue)
                        }
                        value={filterName}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="form-control"
                            type="text"
                            placeholder="Enter Name"
                            value={filterName}
                            onChange={(e) => setFilterName(e.target.value)}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Variety:
                      </label>
                      <Autocomplete
                        disablePortal
                        options={filteredVarietySuggestion
                          .filter((suggestion: any) => suggestion.variety)
                          .map((suggestion: any) => suggestion.variety)}
                        onChange={(event, newValue) =>
                          handleAutocompleteFilter("variety", newValue)
                        }
                        value={filterVariety}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="form-control"
                            type="text"
                            placeholder="Enter Variety"
                            value={filterVariety}
                            onChange={(e) => setFilterVariety(e.target.value)}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Hsn No:
                      </label>
                      <Autocomplete
                        disablePortal
                        options={filteredHsnNoSuggestions
                          .filter((suggestion: any) => suggestion.hsn_no || "")
                          .map((suggestion: any) => suggestion.hsn_no || "")}
                        onChange={(event, newValue) =>
                          handleAutocompleteFilter("hsn_no", newValue)
                        }
                        value={filterHsnNo}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="form-control"
                            type="text"
                            placeholder="Enter Hsn No."
                            value={filterHsnNo}
                            onChange={(e) => setFilterHsnNo(e.target.value)}
                          />
                        )}
                      />
                    </div>
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={filterList}
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-github ms-5"
                        onClick={resetList}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}

        <div className="card-datatable table-responsive">
          {loading && <Spinner isFullScreen={false} />}
          <table className="dt-advanced-search table table-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("name")}
                >
                  Name
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("variety")}
                >
                  Variety
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("hsn_no")}
                >
                  Hsn No
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                {permissions.includes("update-product") && (
                  <th
                    className="cursor-pointer"
                    onClick={() => sortTable("status")}
                  >
                    Status
                    <span>
                      <i className="ti ti-arrows-down-up sorting-icon"></i>
                    </span>
                  </th>
                )}
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("created_at")}
                >
                  Created At
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                {permissions.includes("update-product") && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                records.map((item: any, i: number) => (
                  <tr key={item.id}>
                    <td>{(page - 1) * perPage + 1 + i}</td>
                    <td>
                      {
                        <Link
                          to={"#"}
                          onClick={() => {
                            setProductId(item.id);
                          }}
                          title="View Product Details"
                          data-bs-toggle="modal"
                          data-bs-target="#viewProduct"
                        >
                          {item.name}
                        </Link>
                      }
                    </td>
                    <td>{item.variety}</td>
                    <td>{item.hsn_no}</td>
                    {permissions.includes("update-product") && (
                      <td>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="status"
                            defaultChecked={item.status ? true : false}
                            onClick={() => {
                              updateProductStatus(item.id, item.status);
                            }}
                          />
                        </div>
                      </td>
                    )}
                    <td>
                      {moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}
                    </td>
                    {permissions.includes("update-product") && (
                      <td>
                        <>
                          <Link
                            to={`/edit-product/${item.id}`}
                            className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                            title="Edit Product"
                          >
                            <i className="ti ti-pencil ti-md"></i>
                          </Link>
                        </>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={permissions.includes("update-product") ? 6 : 4}
                    className="text-center"
                  >
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          perPage={perPage}
          totalRecords={totalRecords}
          totalPages={totalPages}
          records={records}
          prevButton={prevButton}
          nextButton={nextButton}
        />

        <ViewProduct productId={productId} />
      </div>
    </>
  );
};

export default ProductList;
